module.exports = __webpack_public_path__ + "09205cbdbed7581b426febb894c91fb2.svg";